import { IsNotEmpty, IsString, MinLength, MaxLength, IsArray } from 'class-validator';

export class ResourceGroupResourceQueryDTO {

    @IsNotEmpty()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    resourceGroups: Array<string>;

}
